import React, { useEffect, useMemo, useState } from "react";
import { LogoutOutlined } from "@ant-design/icons";
import { Alert, Button, Modal } from "antd";
import dayjs from "dayjs";
import generatePDF from "../../../components/Customs/generatePDF";
import generateA4PDF from "../../../components/Customs/generateA4PDF";
import { GeneralService } from "../../../Services/GeneralService";
import { notify } from "../../../components/Customs/NotifyProvider";
import generateBillServices from "../../../components/Customs/generateBillServices";
import generateA4PDFService from "../../../components/Customs/generateA4PDFService";

function CheckOutNoteArea({ value, onChange }) {
    return (
        <div style={{ marginTop: 16 }}>
            <label style={{
                display: "block",
                fontSize: 12,
                fontWeight: 600,
                color: "#555",
                marginBottom: 6,
                textTransform: "uppercase",
                letterSpacing: 0.4,
            }}>
                Check-Out Note{" "}
                <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none", fontSize: 11 }}>
                    (optional)
                </span>
            </label>
            <textarea
                placeholder="Add any remarks, damages, or notes about this check-out…"
                value={value}
                rows={3}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    width: "100%",
                    border: "1.5px solid #e4e4e4",
                    borderRadius: 8,
                    fontSize: 13,
                    color: "#222",
                    padding: "8px 12px",
                    outline: "none",
                    resize: "vertical",
                    boxSizing: "border-box",
                    background: "#fafafa",
                    fontFamily: "inherit",
                    lineHeight: 1.5,
                }}
            />
        </div>
    );
}

export default function CheckOutModal({ open, onClose, onConfirm, form, room, loading, headerImg = "",headerA4Img="", footerImg = "", gst = 0, gstType }) {


    const [now, setNow] = useState(dayjs());
    const [note, setNote] = useState("");
    const [overdueAmount, setOverdueAmount] = useState(0);
    const [step, setStep] = useState(1);
    const [pendingServices, setPendingServices] = useState([]);
    const [hasPendingServices, setHasPendingServices] = useState(false);

    useEffect(() => {
        if (step === 2) return;

        const interval = setInterval(() => {
            setNow(dayjs());
        }, 1000);

        return () => clearInterval(interval);
    }, [step]);



    const getPreRequest = async (bl_id, br_id) => {
        try {
            const res = await GeneralService.getServiceRequests(
                "service_requests",
                bl_id,
                br_id
            );

            const services = res.data || [];

            const pending = services.filter(
                (item) => item.status?.toLowerCase() === "pending"
            );

            setPendingServices(pending);
            setHasPendingServices(pending.length > 0);

            console.log("Pending Services:", pending);

        } catch (error) {
            console.error(error);
        }
    };

    const getRequestData = async (bl_id, br_id) => {
        try {
            const res = await GeneralService.getServiceRequests(
                "service_requests",
                bl_id,
                br_id
            );

            const services = res.data || [];

            console.log("services:", services);
            return services;


        } catch (error) {
            console.error(error);
        }
    };

    const handleSave = () => setStep(2);

    const handleConfirm = async () => {

        if (hasPendingServices) {
            notify.info(
                "Pending Service Payments",
                "Requested service payments are pending. Please clear all service dues before check-out.",
            )

            return;
        }

        const currentDateTime = dayjs();

        // Actual checkout values
        const act_checkout_time = currentDateTime.format("hh:mm A");
        const act_check_out_date = currentDateTime.format("DD-MM-YYYY");

        let difference_time = "0m";

        if (estCheckoutDateTime?.isValid()) {
            const diffMinutes = currentDateTime.diff(
                estCheckoutDateTime,
                "minute"
            );

            const absMinutes = Math.abs(diffMinutes);

            const days = Math.floor(absMinutes / (24 * 60));
            const hours = Math.floor((absMinutes % (24 * 60)) / 60);
            const minutes = absMinutes % 60;

            let formatted = "";

            if (days) formatted += `${days}d `;
            if (hours) formatted += `${hours}h `;
            if (minutes || (!days && !hours)) formatted += `${minutes}m`;

            // + means exceeded checkout time
            // - means checked out before estimated checkout
            difference_time =
                diffMinutes >= 0
                    ? `+${formatted.trim()}`
                    : `-${formatted.trim()}`;
        }

        const payload = {
            status: "check_out",
            note,
            act_checkout_time,
            act_check_out_date,
            difference_time,
            form,
        };

        console.log(payload);

        // onConfirm(payload);
        await onConfirm({ status: "check_out", note, form, act_checkout_time, act_check_out_date, difference_time, overdue_amount: overdueAmount });
    };

    const handleCancel = () => {
        setStep(1);
        setNote("");
        setOverdueAmount(0);
        onClose();
    };

    useEffect(() => {
        getPreRequest(form.bl_id, form.br_id)
    }, [open])

    // Add this inside CheckOutModal component:
    const hasGuestDetails =
        form?.guest_name || form?.phone || form?.email;

    const checkInDateTime = useMemo(() => {
        if (!form?.check_in || !form?.check_in_time) return null;

        return dayjs(
            `${form.check_in} ${form.check_in_time}`,
            "YYYY-MM-DD hh:mm A"
        );
    }, [form]);

    const estCheckoutDateTime = useMemo(() => {
        if (!form?.check_out || !form?.check_out_time) return null;

        return dayjs(
            `${form.check_out} ${form.check_out_time}`,
            "YYYY-MM-DD hh:mm A"
        );
    }, [form]);

    const formatDuration = (minutes) => {
        const days = Math.floor(minutes / (60 * 24));
        const hours = Math.floor((minutes % (60 * 24)) / 60);
        const mins = minutes % 60;

        let result = "";

        if (days) result += `${days}d `;
        if (hours) result += `${hours}h `;
        if (mins || (!days && !hours)) result += `${mins}m`;

        return result.trim();
    };

    const stayDuration =
        checkInDateTime && now
            ? formatDuration(now.diff(checkInDateTime, "minute"))
            : "—";

    const remainingMinutes =
        estCheckoutDateTime
            ? estCheckoutDateTime.diff(now, "minute")
            : null;

    const isOverdue = remainingMinutes < 0;

    const checkoutStatusText =
        remainingMinutes == null
            ? "—"
            : isOverdue
                ? `+${formatDuration(Math.abs(remainingMinutes))} overdue`
                : `${formatDuration(remainingMinutes)} left`;

    useEffect(() => {
        if (isOverdue && remainingMinutes != null && room?.price_per_hour) {
            const overdueHours = Math.abs(remainingMinutes) / 60;
            const amount = Math.round(overdueHours * room.price_per_hour);
            setOverdueAmount(amount);
        } else {
            setOverdueAmount(0);
        }
    }, [isOverdue, remainingMinutes, room?.price_per_hour]);
    useEffect(() => {
        if (!open) {
            setStep(1);
            setNote("");
            setOverdueAmount(0);
        }
    }, [open]);


    const calculateFinalBill = ({ ps = {}, form, room, services = [], overdueAmount = 0 }) => {
        const toNum = (v) => {
            const n = Number(String(v ?? 0).replace(/,/g, ""));
            return Number.isFinite(n) ? n : 0;
        };

        const serviceTotal = services.reduce(
            (sum, item) => sum + toNum(item.total_amount),
            0
        );

        const roomTotal = toNum(ps.total_amount || form?.total_amount);
        const paidAmount = toNum(ps.paid_amount || form?.paid_amount);
const paymentType = String(
    ps.amount_type ??
    form?.amount_type ??
    ""
).trim().toLowerCase();

const currentPaymentStatus = String(
    ps.payment_status ??
    form?.payment_status ??
    ""
).trim().toLowerCase();

const isAdvancePayment =
    paymentType.includes("advance") &&
    !currentPaymentStatus.includes("fully paid");

const receivedAdvance = isAdvancePayment
    ? toNum(ps.received_advance ?? ps.paid_amount ?? form?.paid_amount ?? 0)
    : 0;
        const discountAmount = toNum(ps.discount_amount);
        const oldRemaining = toNum(ps.remaining_payable);

        const finalGrandTotal = roomTotal + serviceTotal + toNum(overdueAmount);
        const finalRemainingPayable = Math.max(
            oldRemaining + serviceTotal + toNum(overdueAmount),
            0
        );

        return {
            serviceTotal,
            grandTotal: finalGrandTotal,
            paidAmount,
            receivedAdvance,
            remainingPayable: finalRemainingPayable,
            discountAmount,
            paymentStatus:
                finalRemainingPayable <= 0 ? "Fully Paid" : ps.payment_status || "Pending",
        };
    };

    const handlePrintBill = async () => {
        let ps = {};

        console.log('form', form);


        try {
            ps = form?.pricing_summary
                ? typeof form.pricing_summary === "string"
                    ? JSON.parse(form.pricing_summary)
                    : form.pricing_summary
                : {};
        } catch {
            ps = {};
        }

        const services = await getRequestData(form.bl_id, form.br_id);

        const finalBill = calculateFinalBill({
            ps,
            form,
            room,
            services: Array.isArray(services) ? services : [],
            overdueAmount,
        });

        generateBillServices({
            form,
            showUnitName: true,
            bookIds: [form?.br_id || form?.id],
            rooms: [room],
            services: Array.isArray(services) ? services : [],

            serviceTotal: finalBill.serviceTotal,
            grandTotal: finalBill.grandTotal,
            paidAmount: finalBill.paidAmount,
            receivedAdvance: finalBill.receivedAdvance,
            remainingPayable: finalBill.remainingPayable,
            discountAmount: finalBill.discountAmount,
            paymentStatus: finalBill.paymentStatus,

            amountType: ps.amount_type || null,
            loyaltyDiscountPercent: Number(ps.loyalty_discount_percent || 0),
            loyaltyDiscountAmount: Number(ps.loyalty_discount_amount || 0),

            nights: Number(ps.duration_nights || 0),
            gst: Number(ps.gst_percent || 0),
            gstPercent: Number(ps.gst_percent || 0),
            gstAmount: Number(ps.gst_amount || 0),
            gstType: ps.gst_type || gstType,

            totalHours: Number(ps.duration_hours || 0),
            bookingType: ps.booking_type || "Day",
            ratePerHour: Number(ps.rate_per_hour || room?.price_per_hour || 0),

            overdue_amount: Number(overdueAmount || 0),
            early_checkin_amount: Number(ps.early_checkin_amount || 0),
            overdue_duration:
                ps.overdue_duration ||
                (isOverdue ? formatDuration(Math.abs(remainingMinutes)) : ""),

            headerImg,
            footerImg,
        });
    };

    const handlePrintA4Bill = async () => {
        let ps = {};

        console.log('form', form);


        try {
            ps = form?.pricing_summary
                ? typeof form.pricing_summary === "string"
                    ? JSON.parse(form.pricing_summary)
                    : form.pricing_summary
                : {};
        } catch {
            ps = {};
        }

        const services = await getRequestData(form.bl_id, form.br_id);

        const finalBill = calculateFinalBill({
            ps,
            form,
            room,
            services: Array.isArray(services) ? services : [],
            overdueAmount,
        });

        generateA4PDFService({
            form,
            showUnitName: false,
            bookIds: [form?.br_id || form?.id],
            rooms: [room],
            services: Array.isArray(services) ? services : [],

            serviceTotal: finalBill.serviceTotal,
            grandTotal: finalBill.grandTotal,
            paidAmount: finalBill.paidAmount,
            receivedAdvance: finalBill.receivedAdvance,
            remainingPayable: finalBill.remainingPayable,
            discountAmount: finalBill.discountAmount,
            paymentStatus: finalBill.paymentStatus,

            amountType: ps.amount_type || null,
            loyaltyDiscountPercent: Number(ps.loyalty_discount_percent || 0),
            loyaltyDiscountAmount: Number(ps.loyalty_discount_amount || 0),

            nights: Number(ps.duration_nights || 0),
            gst: Number(ps.gst_percent || 0),
            gstPercent: Number(ps.gst_percent || 0),
            gstAmount: Number(ps.gst_amount || 0),
            gstType: ps.gst_type || gstType,

            totalHours: Number(ps.duration_hours || 0),
            bookingType: ps.booking_type || "Day",
            ratePerHour: Number(ps.rate_per_hour || room?.price_per_hour || 0),

            overdue_amount: Number(overdueAmount || 0),
            early_checkin_amount: Number(ps.early_checkin_amount || 0),
            overdue_duration:
                ps.overdue_duration ||
                (isOverdue ? formatDuration(Math.abs(remainingMinutes)) : ""),

            headerImg: headerA4Img,
            footerImg,
        });
    };

    return (
        <>
            {!hasGuestDetails ? (
                <Modal
                    open={open}
                    onCancel={handleCancel}
                    footer={[
                        <Button key="close" type="primary" onClick={handleCancel}>
                            Close
                        </Button>,
                    ]}
                    centered
                    width={450}
                    destroyOnClose
                    title={
                        <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#000000ff" }}>
                            <LogoutOutlined style={{ fontSize: 20 }} />
                            <span style={{ fontWeight: 700, fontSize: 15 }}>
                                Guest Details Not Found
                            </span>
                        </div>
                    }
                >
                    <Alert
                        type="warning"
                        showIcon
                        message={
                            <span style={{ fontWeight: 600 }}>
                                User details not found or guest has not checked in yet.
                            </span>
                        }
                        description="Please verify guest booking/check-in status before proceeding with check-out."
                    />
                </Modal>
            ) : (
                <Modal
                    open={open}
                    onCancel={handleCancel}
                    title={
                        <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#c41d7f" }}>
                            <LogoutOutlined style={{ fontSize: 20 }} />
                            <span style={{ fontWeight: 700, fontSize: 15 }}>
                                Confirm Check-Out
                            </span>
                        </div>
                    }
                    footer={
                        step === 1 ? [
                            <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                            <Button key="save" type="primary" onClick={handleSave}>Save</Button>,
                        ] : [

                            <Button key="printBill" onClick={handlePrintBill}>Print Bill</Button>,

                            <Button key="printA4" onClick={handlePrintA4Bill}
                            // () => {
                            //     const ps = form?.pricing_summary
                            //         ? (typeof form.pricing_summary === "string"
                            //             ? JSON.parse(form.pricing_summary)
                            //             : form.pricing_summary)
                            //         : {};

                            //     console.log("ps parsed:", ps);
                            //     console.log("form.br_id:", form?.br_id);
                            //     console.log("form.id:", form?.id);

                                // generateA4PDF({
                                //     form,
                                //     bookIds: [form?.br_id || form?.id],
                                //     rooms: [room],
                                //     pricing_summary: ps,
                                //     grandTotal: ps.total_amount || Number(form?.total_amount) || 0,
                                //     paidAmount: ps.paid_amount || Number(form?.paid_amount) || 0,
                                //     receivedAdvance: ps.received_advance || 0,
                                //     remainingPayable: ps.remaining_payable || 0,
                                //     discountAmount: ps.discount_amount || 0,
                                //     amountType: ps.amount_type || null,
                                //     paymentStatus: ps.payment_status || "",
                                //     loyaltyDiscountPercent: ps.loyalty_discount_percent || 0,
                                //     loyaltyDiscountAmount: ps.loyalty_discount_amount || 0,
                                //     nights: ps.duration_nights || 0,
                                //     gst: ps.gst_percent || 0,
                                //     gstPercent: ps.gst_percent || 0,
                                //     gstAmount: ps.gst_amount || 0,
                                //     hourlyBook: ps.booking_type === "hourly",
                                //     totalHours: ps.duration_hours || 0,
                                //     bookingType: ps.booking_type || "Day",
                                //     ratePerHour: ps.rate_per_hour || room?.price_per_hour || 0,
                                //     overdue_amount: ps.overdue_amount || overdueAmount || 0,
                                //     early_checkin_amount: ps.early_checkin_amount || 0,
                                //     overdue_duration: ps.overdue_duration || (isOverdue ? formatDuration(Math.abs(remainingMinutes)) : ""),
                                //     headerImg,
                                //     footerImg,
                                // });
                            // }}
                            >Print A4</Button>,


                            <Button
                                key="confirm"
                                danger
                                type="primary"
                                loading={loading}
                                icon={<LogoutOutlined />}
                                onClick={handleConfirm}
                            >
                                Confirm Check-Out
                            </Button>,
                        ]
                    }
                    width={800}
                    centered
                    destroyOnClose
                >
                    {/* Guest summary alert */}
                    <Alert
                        type="warning"
                        showIcon
                        message={
                            <span style={{ fontWeight: 600 }}>
                                You are about to check out this guest. Please review the details below.
                            </span>
                        }
                        description={
                            <div
                                style={{
                                    marginTop: 10,
                                    display: "grid",
                                    gridTemplateColumns: "repeat(3, 1fr)",
                                    gap: "6px 20px",
                                }}
                            >
                                {[
                                    ["Guest Name", form?.guest_name || "—"],
                                    ["Phone", form?.phone || "—"],
                                    ["Email", form?.email || "—"],
                                    ["Room", room?.room_name || "—"],
                                    ["Room No.", `#${room?.room_number || "—"}`],
                                    ["Guests", form?.guests ?? "—"],
                                ].map(([k, v]) => (
                                    <div
                                        key={k}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 1,
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: 10,
                                                color: "#888",
                                                textTransform: "uppercase",
                                                letterSpacing: 0.4,
                                                fontWeight: 600,
                                            }}
                                        >
                                            {k}
                                        </span>
                                        <span
                                            style={{
                                                fontSize: 13,
                                                fontWeight: 600,
                                                color: "#222",
                                            }}
                                        >
                                            {v}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        }
                    />

                    <Alert
                        type="info"
                        description={
                            <div
                                style={{
                                    marginTop: 10,
                                    display: "grid",
                                    gridTemplateColumns: "repeat(3, 1fr)",
                                    gap: "6px 20px",
                                }}
                            >
                                {
                                    [
                                        ["Payment Mode", form?.payment_mode || "—"],
                                        ["Check-In", `${form?.check_in || ""}, ${form?.check_in_time || ""}`],
                                        [
                                            "Current Check-Out",
                                            now.format("YYYY-MM-DD, hh:mm:ss A"),
                                        ],
                                        [
                                            "Est. Check-Out",
                                            `${form?.check_out || ""}, ${form?.check_out_time || ""}`,
                                        ],
                                        ["Stay Duration", stayDuration],
                                        ["Total Payable", (() => {
                                            const ps = form?.pricing_summary
                                                ? (typeof form.pricing_summary === "string"
                                                    ? JSON.parse(form.pricing_summary)
                                                    : form.pricing_summary)
                                                : {};
                                            const early = Number(ps.early_checkin_amount || 0);
                                            return `₹${Number(ps.total_amount || 0).toLocaleString()}${early > 0 ? ` (incl. ₹${early.toLocaleString()} early check-in)` : ""}`;
                                        })()],
                                        ...(overdueAmount > 0 ? [["Total + Overdue", `₹${(Number((() => {
                                            const ps = form?.pricing_summary
                                                ? (typeof form.pricing_summary === "string"
                                                    ? JSON.parse(form.pricing_summary)
                                                    : form.pricing_summary)
                                                : {};
                                            return ps.total_amount || 0;
                                        })()) + Number(overdueAmount)).toLocaleString()}`]] : []),


                                    ].map(([k, v]) => (
                                        <div
                                            key={k}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 10,
                                                    color: "#888",
                                                    textTransform: "uppercase",
                                                    letterSpacing: 0.4,
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {k}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    color:
                                                        k === "Stay Duration"
                                                            ? "#1677ff"
                                                            : "#222",
                                                }}
                                            >

                                                {v}
                                            </span>
                                        </div>
                                    ))}

                                <div
                                    style={{
                                        marginTop: 16,
                                        padding: "12px 16px",
                                        borderRadius: 8,
                                        background: isOverdue ? "#fff1f0" : "#f6ffed",
                                        border: `1px solid ${isOverdue ? "#ffccc7" : "#b7eb8f"
                                            }`,
                                        textAlign: "center",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: 12,
                                            color: "#666",
                                            marginBottom: 4,
                                            textTransform: "uppercase",
                                            fontWeight: 600,
                                        }}
                                    >
                                        Checkout Status
                                    </div>

                                    <div
                                        style={{
                                            fontSize: 18,
                                            fontWeight: 700,
                                            color: isOverdue ? "#cf1322" : "#389e0d",
                                        }}
                                    >
                                        {checkoutStatusText}
                                    </div>
                                </div>

                            </div>
                        }

                    />
                    {hasPendingServices && (
                        <div
                            style={{
                                gridColumn: "span 2",
                                marginTop: 16,
                                padding: "12px 16px",
                                borderRadius: 8,
                                background: "#fff7e6",
                                border: "1px solid #ffd591",
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 12,
                                    color: "#ad6800",
                                    marginBottom: 4,
                                    textTransform: "uppercase",
                                    fontWeight: 700,
                                }}
                            >
                                Service Payment Pending
                            </div>

                            <div
                                style={{
                                    fontSize: 15,
                                    fontWeight: 700,
                                    color: "#d46b08",
                                }}
                            >
                                Requested service payments are pending. Please clear all service dues before check-out.
                            </div>

                            <div
                                style={{
                                    marginTop: 8,
                                    fontSize: 12,
                                    color: "#666",
                                }}
                            >
                                Pending Services: {pendingServices.length}
                            </div>
                        </div>
                    )}

                    {/* Overdue Amount input — BEFORE note */}
                    <div style={{ marginTop: 16 }}>
                        <label style={{
                            display: "block",
                            fontSize: 12,
                            fontWeight: 600,
                            color: isOverdue ? "#cf1322" : "#555",
                            marginBottom: 6,
                            textTransform: "uppercase",
                            letterSpacing: 0.4,
                        }}>
                            Overdue Amount{" "}
                            <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none", fontSize: 11 }}>
                                {isOverdue
                                    ? `(${formatDuration(Math.abs(remainingMinutes))} × ₹${room?.price_per_hour}/hr)`
                                    : "(no overdue)"}
                            </span>
                        </label>
                        <input
                            type="number"
                            min={0}
                            value={overdueAmount}
                            onChange={(e) => setOverdueAmount(parseFloat(e.target.value) || 0)}
                            style={{
                                width: "100%",
                                border: `1.5px solid ${isOverdue ? "#ffccc7" : "#e4e4e4"}`,
                                borderRadius: 8,
                                fontSize: 16,
                                fontWeight: 700,
                                color: isOverdue ? "#cf1322" : "#222",
                                padding: "8px 12px",
                                outline: "none",
                                boxSizing: "border-box",
                                background: isOverdue ? "#fff1f0" : "#fafafa",
                                fontFamily: "inherit",
                            }}
                        />
                    </div>

                    <CheckOutNoteArea value={note} onChange={setNote} />
                </Modal>
            )}
        </>
    );
}